/**
 * Redakční systém JSR - administrace
 * jquery_start.js
 * Startovací funkce pro JQuery
 *
 * @package zaklad
 *
 * @author Josef Šmíd <josef@skit.cz>
 * @copyright (c) 2007-2022 Josef Šmíd
 * @version 2.5.3
 */

$(document).ready(function ()
{

  var html_timeline = '';
  var onas = parseFloat($('.onas_6').width());

  $(".onas_6_text>div").each(function (index) {
    $(this).attr('data-slide2', index);
    if (index == 0)
      $(this).addClass('vybrano_onass');

    $(this).css('width', onas);
    if ($(this).children("div").children("p").children("em").html())
    {
      html_timeline = html_timeline + '<div class="vyber_timeline"><div class="cara_timeline"><div class="cara_timeline_vyb"></div></div><div class="vyber_timeline_text"><p>' + $(this).children("div").children("p").children("em").html() + '</p></div></div>';
    }

  });


  if (html_timeline)
    $(".timeline_vyber").append(html_timeline);


  if (/*$('body').width() <= 1000*/ window.matchMedia('(max-width: 1000px)').matches)
  {
    var timeline = parseFloat($('.timeline').width()) / 3;

    $(".vyber_timeline").each(function (index) {
      $(this).css('width', timeline);

    });
    var onas_sirka = 0;
    
    $(".onas_6_text>div").each(function (index) {
      var onas_sirka_celek = 0;
      $(this).children("div").each(function (index) {
        onas_sirka_celek = onas_sirka_celek + $(this).height();
      });
      if (onas_sirka < onas_sirka_celek)
        onas_sirka = onas_sirka_celek;

    });
    if (onas_sirka)
      $('.onas_6').css('height', onas_sirka + 40);
  }
  var pocet = Math.round(parseFloat($('.timeline').width()) / parseFloat($('.vyber_timeline').width())) - 1;
  $(".vyber_timeline").each(function (index) {
    $(this).attr('data-slide2-v', index);
    if (index == 0)
    {
      $(this).addClass('vybrano_onass_timeline');
      $(this).addClass('vyber_timeline_prvni');
    }
    if (index > pocet)
      $(this).hide();
  });





  $('.onas_righ_2').click(function () {
    if(!$(this).hasClass( "dis_button" ))
    {
      $(this).addClass('dis_button'); 

      var aktual = $('.vybrano_onass');
      var next = parseFloat(aktual.attr('data-slide2')) + 1;
      var next_next = parseFloat(next) + 1;

      if ($('*[data-slide2="' + next + '"]').length)
      {
        var next_el = $('*[data-slide2="' + next + '"]');
        var posun = parseFloat(aktual.width()) - parseFloat($('.onas_6_text').css('left')) + parseFloat(aktual.css('margin-right'));
        $('.onas_6_text').animate({left: '-' + posun + 'px'}, function () {
          aktual.removeClass('vybrano_onass');
          next_el.addClass('vybrano_onass');

          $('.vybrano_onass_timeline').removeClass('vybrano_onass_timeline');
          $('*[data-slide2-v="' + next + '"]').addClass('vybrano_onass_timeline');


          if (next > 0)
            $('.onas_left_2').css('opacity', '100%');

          timeline_slider();
          $('.dis_button').removeClass('dis_button');
        });
      }
      if ($('*[data-slide2="' + next_next + '"]').length == 0)
      {
        $('.onas_righ_2').css('opacity', '30%');
      }
    }
  });
  $('.onas_left_2').click(function () {
    if(!$(this).hasClass( "dis_button" ))
    {
      $(this).addClass('dis_button'); 
  
      var aktual = $('.vybrano_onass');
      var next = parseFloat(aktual.attr('data-slide2')) - 1;

      if ($('*[data-slide2="' + next + '"]').length)
      {
        var next_el = $('*[data-slide2="' + next + '"]');
        var posun = parseFloat($('.onas_6_text').css('left')) + parseFloat(next_el.width()) + parseFloat(aktual.css('margin-right'));
        $('.onas_6_text').animate({left: '' + posun + 'px'}, function () {
          aktual.removeClass('vybrano_onass');
          next_el.addClass('vybrano_onass');

          $('.vybrano_onass_timeline').removeClass('vybrano_onass_timeline');
          $('*[data-slide2-v="' + next + '"]').addClass('vybrano_onass_timeline');

          if (next == 0)
            $('.onas_left_2').css('opacity', '30%');
          $('.onas_righ_2').css('opacity', '100%');


          timeline_slider();
          $('.dis_button').removeClass('dis_button');
        });
      }
    }
  });

  $('.vyber_timeline').click(function () {
    var aktual = $('.vybrano_onass');
    var next = parseFloat($(this).attr('data-slide2-v'));
    if (parseFloat(aktual.attr('data-slide2')) == next)
      return;
    var aktual_index = parseFloat(aktual.attr('data-slide2'));

    if ($('*[data-slide2-v="' + next + '"]').length)
    {

      var next_el = $('*[data-slide2="' + next + '"]');

      if (aktual_index + 1 == next)
      {

        var next_next = parseFloat(next) + 1;
        var posun = parseFloat(aktual.width()) - parseFloat($('.onas_6_text').css('left')) + parseFloat(aktual.css('margin-right'));

        $('.onas_6_text').animate({left: '-' + posun + 'px'}, function () {
          aktual.removeClass('vybrano_onass');
          next_el.addClass('vybrano_onass');
          if (next > 0)
            $('.onas_left_2').show();
          $('.vybrano_onass_timeline').removeClass('vybrano_onass_timeline');
          $('*[data-slide2-v="' + next + '"]').addClass('vybrano_onass_timeline');
          

          if (next > 0)
            $('.onas_left_2').css('opacity', '100%');
          
          if(parseFloat($('.timeline_vyber').find('.vyber_timeline:last').attr('data-slide2-v')) === next)$('.onas_righ_2').css('opacity', '30%');

          timeline_slider();
        });


      } else if (aktual_index - 1 == next)
      {
        var posun = parseFloat($('.onas_6_text').css('left')) + parseFloat(next_el.width()) + parseFloat(aktual.css('margin-right'));
        $('.onas_6_text').animate({left: '' + posun + 'px'}, function () {
          aktual.removeClass('vybrano_onass');
          next_el.addClass('vybrano_onass');
          $('.vybrano_onass_timeline').removeClass('vybrano_onass_timeline');
          $('*[data-slide2-v="' + next + '"]').addClass('vybrano_onass_timeline');

          if (next == 0)
            $('.onas_left_2').css('opacity', '30%');
          $('.onas_righ_2').css('opacity', '100%');

          timeline_slider();
        });
      } else
      {
        var posun = parseFloat($('.onas_6_text').css('left'));
        if (aktual_index > next)
        {
          $(".onas_6_text>div").each(function (index, element) {
            if (parseFloat($(element).attr('data-slide2')) >= next && aktual_index > parseFloat($(element).attr('data-slide2')))
            {
              posun = posun + parseFloat($(element).width()) + parseFloat($(element).css('margin-right'));
            }
          });
          
          $('.onas_6_text').animate({left: '' + posun + 'px'}, function () {
            aktual.removeClass('vybrano_onass');
            next_el.addClass('vybrano_onass');

            $('.vybrano_onass_timeline').removeClass('vybrano_onass_timeline');
            $('*[data-slide2-v="' + next + '"]').addClass('vybrano_onass_timeline')

            if (next == 0)
              $('.onas_left_2').css('opacity', '30%');
            $('.onas_righ_2').css('opacity', '100%');

            timeline_slider();
          });
        } else if (aktual_index < next)
        {
          $(".onas_6_text>div").each(function (index, element) {
            if (parseFloat($(element).attr('data-slide2')) < next && aktual_index <= parseFloat($(element).attr('data-slide2')))
            {
              posun = posun - parseFloat($(element).width()) - parseFloat($(element).css('margin-right'));
            }
          });

          $('.onas_6_text').animate({left: '' + posun + 'px'}, function () {
            aktual.removeClass('vybrano_onass');
            next_el.addClass('vybrano_onass');
            if (next > 0)
              $('.onas_left_2').show();

            $('.vybrano_onass_timeline').removeClass('vybrano_onass_timeline');
            $('*[data-slide2-v="' + next + '"]').addClass('vybrano_onass_timeline');


            if (next > 0)
              $('.onas_left_2').css('opacity', '100%');

            if(parseFloat($('.timeline_vyber').find('.vyber_timeline:last').attr('data-slide2-v')) === next)$('.onas_righ_2').css('opacity', '30%');  
            
            timeline_slider();
          });


        }
      }
    }

  });
  var slider_onas = null;
  if (window.matchMedia('(max-width: 600px)').matches )
  {
    if(!slider_onas && $('.onas_7_text').length > 0)slider_onas = $('.onas_7_text').bxSlider({
          mode: 'fade',
          speed: 0,
          infiniteLoop: true,
          controls: true,
          touchEnabled: true,
          adaptiveHeight: false,
          preloadImages: 'all',
          captions: true
     });

   } 
   $(window).bind("resize", function (e) { 
    if (window.matchMedia('(max-width: 600px)').matches )
    {
      if(!slider_onas && $('.onas_7_text').length > 0)slider_onas = $('.onas_7_text').bxSlider({
          mode: 'fade',
          speed: 0,
          infiniteLoop: true,
          controls: true,
          touchEnabled: true,
          adaptiveHeight: false,
          preloadImages: 'all',
          captions: true
      });
      if(slider_onas && $('.onas_7_text').length > 0)slider_onas.reloadSlider();
    }
    else
    {
      if(slider_onas && $('.onas_7_text').length > 0)slider_onas.destroySlider();
    }
  });

});
function timeline_slider()
{

  var pocet = Math.round(parseFloat($('.timeline').width()) / parseFloat($('.vyber_timeline').width())) - 1;

  var aktual = $('.vybrano_onass_timeline');
  var next = parseFloat(aktual.attr('data-slide2-v'));
  var next_next = parseFloat(next) + 1;
  var next_minus = parseFloat(next) - 1;
  var posun = '';
  if ($('*[data-slide2-v="' + next_next + '"]').length)
  {
    if ($('*[data-slide2-v="' + next_next + '"]').is(':hidden'))
    {
      $('*[data-slide2-v="' + next_next + '"]').show();

      posun = parseFloat($('.timeline_vyber').css('left')) - parseFloat($('.vyber_timeline').width());

      $('.timeline_vyber').animate({left: '' + posun + 'px'}, function () {

        var skryt = parseFloat(next) - parseFloat(pocet);
        $('*[data-slide2-v="' + skryt + '"]').hide();

        $('.timeline_vyber').css('left', '0');
      });


    }
  }
  if ($('*[data-slide2-v="' + next_minus + '"]').length)
  {

    if ($('*[data-slide2-v="' + next_minus + '"]').is(':hidden'))
    {
      var posumm = parseFloat($('.timeline_vyber').css('left')) - parseFloat($('.vyber_timeline').width());
      $('*[data-slide2-v="' + next_minus + '"]').show();
      $('.timeline_vyber').css('left', posumm);
      posun = parseFloat($('.timeline_vyber').css('left')) + parseFloat($('.vyber_timeline').width());




      $('.timeline_vyber').animate({left: '' + posun + 'px'}, function () {
        var skryt = parseFloat(next) + parseFloat(pocet);
        $('*[data-slide2-v="' + skryt + '"]').hide();

        $('.timeline_vyber').css('left', '0');
      });

    }
  }


}
$(window).resize(function () {


  var timeline_full = parseFloat($('.timeline').width());
  $('.dis_button').removeClass('dis_button');

  $('.vybrano_onass').removeClass('vybrano_onass');
  $(".onas_6_text>div").each(function (index) {
    if (index == 0)
      $(this).addClass('vybrano_onass');

    $(this).css('width', timeline_full);
  });

  $('.onas_6_text').css('left', '0');
  if (/*$('body').width() <= 1000*/ window.matchMedia('(max-width: 1000px)').matches)
  {
    var timeline = parseFloat($('.timeline').width()) / 3;

    $(".vyber_timeline").each(function (index) {
      $(this).css('width', timeline);
    });
  }
  else
  {
    var timeline = parseFloat($('.timeline').width()) / 7;

    $(".vyber_timeline").each(function (index) {
      $(this).css('width', timeline);
    });
  }
  $('.timeline_vyber').css('left', '0');
  var pocet = Math.round(parseFloat($('.timeline').width()) / parseFloat($('.vyber_timeline').width())) - 1;

  $('.vybrano_onass_timeline').removeClass('vybrano_onass_timeline');
  $('.vyber_timeline_prvni').removeClass('vyber_timeline_prvni');
  $('.vyber_timeline').show();
  $(".vyber_timeline").each(function (index) {
    if (index == 0)
    {
      $(this).addClass('vybrano_onass_timeline');
      $(this).addClass('vyber_timeline_prvni');
    }
    if (index > pocet)
      $(this).hide();
  });
  if (/*$('body').width() <= 1000*/ window.matchMedia('(max-width: 1000px)').matches)
  {
    var onas_sirka = 0;
   $(".onas_6_text>div").each(function (index) {
      var onas_sirka_celek = 0;
      $(this).children("div").each(function (index) {
        onas_sirka_celek = onas_sirka_celek + $(this).height();
      });
      if (onas_sirka < onas_sirka_celek)
        onas_sirka = onas_sirka_celek;

    });
    if (onas_sirka)
      $('.onas_6').css('height', onas_sirka + 40);
  }
  else
  {
    $('.onas_6').css('height','24.1vw');
  }
  $('.onas_left_2').css('opacity', '30%');
  $('.onas_righ_2').css('opacity', '100%');
});